<template>
    <el-form :model="custTaxPayType" :rules="rules" ref="ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">编码</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="code">
                        <el-input type="text" :disabled="id != null" v-model="custTaxPayType.code"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="name">
                        <el-input type="text" v-model="custTaxPayType.name"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">纳税类型</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="stdValue">
                        <el-select placeholder="请选择" v-model="custTaxPayType.stdValue">
                            <el-option v-for="taxPayType in taxPayTypeList" :key="taxPayType.value" :label="taxPayType.text" :value="taxPayType.value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    export default{
        name: 'swb-cust-tax-pay-type-save',
        desc: '自定义纳税类型保存',
        props: ["id"],
        data: function () {
            let checkName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('名称不能为空'));
                } else {
                    if(value.length > 15) {
                        callback(new Error('名称最多15个字'));
                    } else {
                        callback();
                    }
                }
            };
            let checkCode = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('编码不能为空'));
                } else {
                    callback();
                }
            };
            let checkCStdValue = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请选择纳税类型'));
                } else {
                    callback();
                }
            };
            return {
                custTaxPayType: {},
                taxPayTypeList: getEnumList('taxPayType'),
                taxPayTypeMap: getEnumMap("taxPayType", "value2text"),
                rules: {
                    name: [{validator: checkName, trigger: 'blur'}],
                    code: [{validator: checkCode, trigger: 'blur'}],
                    stdValue: [{validator: checkCStdValue, trigger: 'change'}]
                },
            }
        },
        created: function () {
            //
            if(!Utils.isNoB(this.id)) {
                this.getCustTaxPayType();
            }
        },
        methods: {
            //
            getCustTaxPayType: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                //
                let msgBoxDlg = MsgBox.loading();
                merchtComnApi.getCustTaxPayTypeById(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let custTaxPayType = result.data;
                        self.custTaxPayType = Utils.merge({}, custTaxPayType);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        //
                        let custTaxPayType = self.custTaxPayType;

                        if(!Utils.isNoB(self.id)) {
                            custTaxPayType.id = self.id;
                        }
                        custTaxPayType.stdName = self.taxPayTypeMap[custTaxPayType.stdValue];
                        //
                        result.type = 'info';
                        result.data = custTaxPayType;
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/CustTaxPayTypeSave.vue